import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixPaymentsV5BalancesBalanceRecordsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'cronulla-jobs._base_domain_': [
      {
        srcPath: '/wix-payments/wixpay-balance-service/internal-api/jobs',
        destPath: '/internal-api/jobs',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/wixpay-balance-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bo-balance-reserve-transactions',
        destPath: '/v1/bo-balance-reserve-transactions',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/update',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/update',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/release',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/release',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/wixpay-balance-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bo-balance-reserve-transactions',
        destPath: '/v1/bo-balance-reserve-transactions',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/update',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/update',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/release',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/release',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/wixpay-balance-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v4/bo-balance-summary',
        destPath: '/v4/bo-balance-summary',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bo-balance-reserve-transactions',
        destPath: '/v1/bo-balance-reserve-transactions',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/update',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/update',
      },
      {
        srcPath:
          '/_api/wixpay-balance-service/v1/bulk/bo-balance-reserve-transactions/release',
        destPath: '/v1/bulk/bo-balance-reserve-transactions/release',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
      {
        srcPath: '/_api/wixpay-balance-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-summary',
        destPath: '/v5/balance-summary',
      },
      {
        srcPath: '/_api/transaction-service/v5/balance-records',
        destPath: '/v5/balance-records',
      },
    ],
    'manage.base44.com': [
      {
        srcPath: '/_api/wixpay-balance-service',
        destPath: '',
      },
    ],
    'payments.base44.com': [
      {
        srcPath: '/_api/wixpay-balance-service',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/wixpay-balances/v5/balance-records',
        destPath: '/v5/balance-records',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/payments/balances/v5/balance-records',
        destPath: '/v5/balance-records',
      },
    ],
    _: [
      {
        srcPath: '/payments/balances/v5/balance-records',
        destPath: '/v5/balance-records',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_payments_balance-records';

/**
 * Retrieves a single balance record by ID for the specified account.
 *
 * Returns an error if the record doesn't exist or doesn't belong to the specified account.
 */
export function getBalanceRecord(payload: object): RequestOptionsFactory<any> {
  function __getBalanceRecord({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.payments.balances.v5.balance_record',
      method: 'GET' as any,
      methodFqn:
        'wix.payments.v5.balances.BalanceRecordsService.GetBalanceRecord',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixPaymentsV5BalancesBalanceRecordsServiceUrl({
        protoPath: '/v5/balance-records/{balanceRecordId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'record.appliedDate' },
              { path: 'record.createdDate' },
              { path: 'record.updatedDate' },
              { path: 'record.paymentInfo.createdDate' },
              { path: 'record.payoutInfo.createdDate' },
              { path: 'record.reserveInfo.hold.createdDate' },
              { path: 'record.reserveInfo.release.createdDate' },
              { path: 'record.reserveInfo.reserveHistoryItems.createdDate' },
              { path: 'record.bookTransferInfo.createdDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getBalanceRecord;
}

/**
 * Retrieves a list of up to 1000 balance records, given the provided paging, filtering, and sorting.
 *
 * Query Balance Records runs with these defaults, which you can override:
 *
 * - `query.sort[0].fieldName` is `applied_date` in `ASC` order
 * - `query.paging.limit` is `20`
 * - `query.paging.offset` is `0` (and `offset` is required when `paging` is set)
 *
 * Filter and sort field names inside `query` must be **snake_case**. They're read from
 * the `query.filter` object and aren't auto-converted. Supported filter fields:
 * `account_profile_id`, `tags`, `payout_id`, `transaction_id`, `types`, and the date
 * ranges `transaction_creation_date`, `paid`, and `created_date`. Any other field returns
 * an `Unsupported query: unknown parameter <field>` error. ID fields accept a single
 * value by equality, `tags` and `types` accept `$in`, and date-range fields accept `$gte`
 * and `$lt`. Supported `sort[i].fieldName` values: `applied_date`,
 * `payment_info.created_date`, `created_date`. At most 1 sort field is allowed.
 *
 * To list every balance record in a payout, filter by `payout_id`.
 *
 * To learn about working with Query methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-field-projection).
 */
export function queryBalanceRecords(
  payload: object
): RequestOptionsFactory<any> {
  function __queryBalanceRecords({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'query.sort.origin.latitude' },
          { path: 'query.sort.origin.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.payments.balances.v5.balance_record',
      method: 'POST' as any,
      methodFqn:
        'wix.payments.v5.balances.BalanceRecordsService.QueryBalanceRecords',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixPaymentsV5BalancesBalanceRecordsServiceUrl({
        protoPath: '/v5/balance-records/query',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'records.appliedDate' },
              { path: 'records.createdDate' },
              { path: 'records.updatedDate' },
              { path: 'records.paymentInfo.createdDate' },
              { path: 'records.payoutInfo.createdDate' },
              { path: 'records.reserveInfo.hold.createdDate' },
              { path: 'records.reserveInfo.release.createdDate' },
              { path: 'records.reserveInfo.reserveHistoryItems.createdDate' },
              { path: 'records.bookTransferInfo.createdDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryBalanceRecords;
}
